import React, { useEffect, useRef, useState } from "react";
import { IDashboardProps } from "./index";
//import { IProps, Left } from "../Left/index";
import { ITodaysProps, TodayTimes } from "../TodayTimes";
import { PrayerTimes } from "../../Services/PrayerTimes";
import { useDispatch, useSelector } from "react-redux";
import { prayerTimesActions } from "../../Redux/PrayerTimesSlice";
import { IPrayerInProgress, PrayerInProgress } from "../PrayerInProgress";
//import { Carousel } from "react-bootstrap";
import {
  getConfigurationState,
  getPrayerTimesState,
} from "../../Redux/GetState";
//import { SlideType } from "../Helpers";
//import "./Style.css";

import {
  IPrayerNotification,
  PrayerNotification,
} from "../PrayerNotification/index";
import loadingImage from "../Images/Loading.gif";
// import { dailyDuas } from "../../Services/Duas";
// import { duasActions } from "../../Redux/DuasSlice";
import { ConfigurationService } from "../../Services/Configuration";
//import { configurationActions } from "../../Redux";
// import { useContainerDimensions } from "../Left/Helpers/UseContainerDimensions";
// import { AnalogClock, IAnalogProps } from "../Analog";

import { DigitalClock, IDigitalProps } from "../Digital";
import { ITimeRemainingProps, TimeRemaining } from "../TimeRemaining";
import { ISunriseProps, Sunrise } from "../Sunrise";
import { IJummaTimesProps, Jumma1, Jumma2 } from "../JummaTimes";
import { DailyMobileView } from "../TodayTimes/DailyMobileView";
import backgroundImage from "../Images/backgroundImage.jpg";
import { Clock } from "../Analog/Clock";
import { Carousel } from "react-bootstrap";
import { dailyDuas } from "../../Services/Duas";
import { configurationActions, duasActions } from "../../Redux";
import { Duas } from "../Duas/Duas";
import { SlideType } from "../Helpers";
import Center from "../Analog/Helper/Center";

interface ISlideIndex {
  index: number | undefined;
}

export const Dashboard: React.FC<IDashboardProps> = (
  props: IDashboardProps,
): JSX.Element => {
  let selectedIndex: ISlideIndex = {
    index: undefined,
  };

  const [loading, setLoading] = useState(false);
  const [activeIndex, setActiveIndex] = useState(selectedIndex);
  const [firstLoad, setFirstLoad] = useState(true);
  const [nextUpdate, setNextUpdate] = useState(new Date());

  const [error, setError] = useState(false);

  const dispatch = useDispatch();
  const { slide } = useSelector(getPrayerTimesState);

  let isMobile = window.innerWidth < 800;

  let width = window.innerWidth;
  let height = window.innerHeight;

  const { configuration } = useSelector(getConfigurationState);

  async function loadDuas() {
    const response = await dailyDuas();

    if (!response) {
      return;
    }

    dispatch(duasActions.setDuas(response));
  }

  async function loadData() {
    if (firstLoad) {
      setLoading(true);
      loadDuas();
    }

    const response = await PrayerTimes();

    if (!response) {
      return;
    }

    dispatch(prayerTimesActions.setPrayerTimes(response));

    await GetConfigurations();

    if (firstLoad) {
      setLoading(false);
      setFirstLoad(false);
    }
  }

  async function GetConfigurations() {
    const response = await ConfigurationService();

    if (!response) {
      return;
    }

    dispatch(configurationActions.setConfiguration(response));
  }

  function addMinutes(date: Date, minutes: number) {
    return new Date(date.getTime() + minutes * 60000);
  }

  function requireUpdate() {
    if (nextUpdate < props.dateTime) {
      let futureDate = addMinutes(props.dateTime, 120);
      loadData();
      setNextUpdate(futureDate);
    }
  }

  useEffect(() => {
    requireUpdate();
  }, [props.dateTime]);

  useEffect(() => {
    let innerSlide = undefined;

    if (slide !== SlideType.Loop) {
      innerSlide = slide;
    }
    const active: ISlideIndex = {
      index: innerSlide,
    };
    setActiveIndex(active);
  }, [slide]);

  const todaysProps: ITodaysProps = {
    dateTime: props.dateTime,
  };

  const notificationProps: IPrayerNotification = {
    dateTime: props.dateTime,
  };

  const prayerInProgressProps: IPrayerInProgress = {
    dateTime: props.dateTime,
  };

  const digitalClockProps: IDigitalProps = {
    dateTime: props.dateTime,
  };

  const timeRemainingProps: ITimeRemainingProps = {
    dateTime: props.dateTime,
  };

  const sunriseProps: ISunriseProps = {
    dateTime: props.dateTime,
  };
  const jummaProps: IJummaTimesProps = {
    dateTime: props.dateTime,
  };

  const preparing = (): JSX.Element => {
    return (
      <div
        style={{
          justifyContent: Center,
          alignItems: Center,
          display: "flex",
          border: 0,
        }}
      >
        <img src={loadingImage} alt="Loading" />
      </div>
    );
  };

  const notifications = (): JSX.Element => {
    return (
      <>
        <PrayerNotification {...notificationProps} />
      </>
    );
  };

  const dashboard = (): JSX.Element => (
    <div
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "100% 100%",
      }}
    >
      <div>
        <div
          style={{
            height: "70vh",
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
          }}
        >
          <table style={{ width: "100%" }}>
            <td
              style={{
                alignItems: "center",
                textAlign: "center",
                verticalAlign: "middle",
                color: "blue",
              }}
            >
              <Clock size={height - 210} dateTime={props.dateTime} />
            </td>
            <td
              style={{
                width: "80%",
                alignItems: "center",
                textAlign: "center",
                verticalAlign: "middle",
                color: "black",
              }}
            >
              <Carousel
                controls={false}
                pause={false}
                indicators={false}
                activeIndex={activeIndex.index}
                slide={true}
              >
                <Carousel.Item interval={60000}>
                  <div>
                    <TimeRemaining dateTime={props.dateTime} />
                  </div>
                </Carousel.Item>
                <Carousel.Item interval={15000}>
                  <PrayerInProgress {...prayerInProgressProps} />
                </Carousel.Item>
                <Carousel.Item interval={15000}>
                  <Duas />
                </Carousel.Item>
              </Carousel>
            </td>
          </table>
        </div>
        <div style={{ height: "30vh" }}>
          <TodayTimes {...todaysProps} />
        </div>
      </div>
    </div>
  );

  const mobileView = (): JSX.Element => {
    return (
      <>
        <>
          <DailyMobileView dateTime={props.dateTime} />
        </>
      </>
    );
  };

  const dashboardDecider = (): JSX.Element => {
    return (
      <>
        {isMobile ? (
          loading ? (
            preparing()
          ) : (
            mobileView()
          )
        ) : (
          <div>{loading ? preparing() : dashboard()}</div>
        )}

        <div>{notifications()}</div>
      </>
    );
  };

  const status = (): JSX.Element => {
    return (
      <>
        <div style={{ position: "fixed", left: 0, bottom: 0 }}>
          {error ? (
            <svg width="10" height="10" xmlns="http://www.w3.org/2000/svg">
              <circle
                fill="none"
                stroke="red"
                stroke-width="25px"
                cx="5"
                cy="5"
                r="10px"
              />
            </svg>
          ) : (
            <svg width="10" height="10" xmlns="http://www.w3.org/2000/svg">
              <circle
                fill="none"
                stroke="green"
                stroke-width="25px"
                cx="5"
                cy="5"
                r="10px"
              />
            </svg>
          )}
          v1.0.0 ({width}x{height})
        </div>
      </>
    );
  };

  return (
    <>
      <>{dashboardDecider()}</>
      <>{status()}</>
    </>
  );
};
